// Omgevingen (privé en gedeeld), eigen thema, agendaverbindingen met Google en Microsoft en een
// paar losse zinnen die nog vast in het Nederlands in de webapp stonden (oprichter 1 okt: alles in
// zes talen). Sleutels in `a.omgeving.*` (app.nl.ts).
export const appOmgevingNl = {
    spaces: {
        mine: 'Mijn omgeving',
        switchLabel: 'Omgeving wisselen',
        choose: 'Kies omgeving',
        private: 'Privé',
        shared: 'Gedeeld',
        dialogTitle: 'Kies je omgeving',
        dialogBody: 'Plan voor jezelf of samen met anderen.',
        close: 'Sluiten',
        current: 'Huidige omgeving',
        privateHint: 'Privé · alleen voor jou',
        sharedHint: 'Gedeeld · samen plannen',
        opening: 'Omgeving openen…',
        failed: 'Wisselen is niet gelukt. Probeer het opnieuw.',
        personalNotice: 'Mijn omgeving · privé: deze planning en gegevens zijn alleen voor jou. Wissel bovenaan naar Gedeeld om samen te plannen.',
    },
    personalTheme: {
        title: 'Mijn thema',
        body: 'Kies het uiterlijk van jouw app. Deze keuze wordt bij je account bewaard en geldt op al je apparaten. Het gedeelde bord en andere gebruikers houden hun eigen thema.',
        auto: 'Thema van mijn huishouden volgen',
        warm: 'Warm en speels',
        calm: 'Zacht en rustig',
        minimal: 'Minimalistisch',
        graphic: 'Strak en grafisch',
        contrast: 'Groot en contrastrijk',
        failed: 'Je thema kon niet worden geladen.',
        retry: 'Opnieuw proberen',
        saved: 'Je thema is opgeslagen.',
    },
    calendarSync: {
        title: 'Mijn agendaverbindingen',
        /** {name} = naam van de omgeving (vet). */
        intro: 'Verbind je primaire Google- of Microsoft-agenda met {name}. Alleen jij beheert deze verbinding. Binnen deze omgeving gelden de gewone toegangsrechten voor geïmporteerde afspraken.',
        details: 'Automatisch elke vijf minuten, van 30 dagen terug tot een jaar vooruit. Herhalingen worden als losse afspraken gesynchroniseerd. Alleen titel, tijden, locatie en notities worden uitgewisseld; geen deelnemers of uitnodigingen. Vergaderingen met deelnemers bewerk je in Google of Outlook.',
        connected: 'Agenda verbonden. Kies Nu synchroniseren om direct te beginnen.',
        failed: 'Verbinden is niet gelukt of geannuleerd. Probeer opnieuw.',
        retry: 'Opnieuw proberen',
        provider: 'Agendadienst',
        google: 'Google Agenda / Gmail',
        googleShort: 'Google Agenda',
        microsoft: 'Microsoft 365 / Outlook',
        direction: 'Synchronisatierichting',
        import: 'Alleen naar AMUMIN',
        export: 'Alleen vanuit AMUMIN',
        both: 'Twee richtingen',
        scope: 'Welke afspraken versturen?',
        scopeMine: 'Afspraken waar ik bij hoor',
        scopeAll: 'Alle afspraken in deze omgeving',
        notConfigured: 'Deze agendadienst moet nog door AMUMIN worden geactiveerd. De bestaande agenda-abonnementen blijven beschikbaar.',
        alreadyConnected: 'Al verbonden',
        connect: 'Agenda verbinden',
        lastSync: 'Laatst gesynchroniseerd: {when}',
        neverSynced: 'Nog niet gesynchroniseerd',
        conflicts: {
            one: '{count} afspraak is aan beide kanten gewijzigd of verwijderd. Hij is behouden. Controleer beide agenda’s en kies welke versie je wilt bewaren.',
            other: '{count} afspraken zijn aan beide kanten gewijzigd of verwijderd. Ze zijn behouden. Controleer beide agenda’s en kies welke versie je wilt bewaren.',
        },
        synced: 'Synchronisatie uitgevoerd.',
        syncNow: 'Nu synchroniseren',
        keepLocal: 'AMUMIN-versies bewaren',
        keepRemote: 'Externe versies bewaren',
        disconnect: 'Verbinding stoppen',
        disconnectHint: 'Stoppen verwijdert geen afspraken. Om de richting te veranderen, stop je de verbinding en verbind je opnieuw.',
        personalLinks: 'Je persoonlijke agenda blijft privé. Gedeelde abonnementslinks maak je vanuit je gedeelde omgeving.',
    },
    errors: {
        personalSpacePrivate: 'Je persoonlijke omgeving is alleen voor jou. Schakel naar Gedeeld om mensen uit te nodigen of een bord te koppelen.',
        providerNotConfigured: 'Deze agendadienst is nog niet geactiveerd door AMUMIN.',
        alreadyConnected: 'Deze agendadienst is al verbonden. Stop eerst de bestaande verbinding om opnieuw te verbinden.',
    },
    /** Ritten zonder rijder (Vandaag). {names} = wie meegaat, {title} = de afspraak. */
    rideOpen: {
        dropoff: 'Wie brengt {names} naar {title}?',
        dropoffNoNames: 'Wie brengt naar {title}?',
        pickup: 'Wie haalt {names} op bij {title}?',
        pickupNoNames: 'Wie haalt op bij {title}?',
    },
    /** {link} = "Was ik dit niet?" (de link in de e-mail). */
    notMeHint: '{link}: gebruik de link onderaan de e-mail.',
    ingredientsPlaceholder: '500 g gehakt\n1 ui\n1 blik tomaten',
};
//# sourceMappingURL=omgevingApp.nl.js.map